import { Component, Input } from '@angular/core';
import { ModalController, AlertController, IonicModule } from '@ionic/angular';
import { IKeg } from 'app/models/keg';
import { KegDetailPage } from 'app/pages/keg/keg-detail/keg-detail.page';
import { Store } from '@ngrx/store';
import * as fromKeg from "app/state/keg";
import * as fromTap from "app/state/tap";
import * as fromUser from "app/state/user/reducer";
import * as fromSubscription from "app/state/subscription/reducer";
import { ITap, ITapVM } from 'app/models/tap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KegSvgComponent } from 'app/pages/home/taps/keg-svg/keg-svg.component';
import { CornyKegSvgComponent } from 'app/pages/home/taps/cornykeg-svg/cornykeg-svg.component';
import { CornyKeg09SvgComponent } from 'app/pages/home/taps/cornykeg09-svg/cornykeg09-svg.component';
import { CornyKeg12SvgComponent } from 'app/pages/home/taps/cornykeg12-svg/cornykeg12-svg.component';
import { NewKegPage } from 'app/pages/keg/new-keg/new-keg.page';

@Component({
  selector: 'app-keg-chooser',
  templateUrl: './keg-chooser.page.html',
  styleUrls: ['./keg-chooser.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    KegSvgComponent, CornyKegSvgComponent, CornyKeg09SvgComponent, CornyKeg12SvgComponent,
  ],
})
export class KegChooserPage {

  @Input() tap!: ITap;

  barId = this.store.selectSignal(fromUser.selectBarId);
  kegs = this.store.selectSignal(fromKeg.getKegsWithUnitBeverageAndLocation);
  taps = this.store.selectSignal(fromTap.getItemsWithKegAndBeverage);
  isPremium = this.store.selectSignal(fromSubscription.getHasPremium);

  constructor(
    private store: Store,
    private modalController: ModalController,
    private alertController: AlertController,
  ) { }

  freeItemCount = 2;

  isKegDisabled(isPremium: boolean, kegNumber: number) {
    return (kegNumber >= this.freeItemCount && isPremium === false);
  }

  async selectKeg(keg: IKeg, taps: ITapVM[]) {
    const tap = taps.find(x => x.kegId === keg.id)
    if (!!tap) {
      await this.confirmAlert(keg, tap);
    } else if (keg) {
      this.modalController.dismiss({
        keg
      });
    }
  }


  tapExists(kegId: string, taps: ITapVM[]) {
    return taps.findIndex(x => x.kegId === kegId) > -1;
  }

  getTapName(kegId: string, taps: ITapVM[]) {
    return taps.find(x => x.kegId === kegId)?.name;
  }

  getPlaatoName(kegId: string, taps: ITapVM[]) {
    return taps.find(x => x.kegId === kegId)?.plaato?.name;
  }

  getKegtronName(kegId: string, taps: ITapVM[]) {
    return taps.find(x => x.kegId === kegId)?.kegtron?.name;
  }

  getCustomKegMonName(kegId: string, taps: ITapVM[]) {
    return taps.find(x => x.kegId === kegId)?.customKegMon?.name;
  }



  dismiss() {
    this.modalController.dismiss({
      dismissed: true
    });
  }

  async confirmAlert(keg: IKeg, tap: ITap) {
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Already attached to another tap, are you sure you want to change?',
      buttons: [{
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary'
      }, {
        text: 'Okay',
        handler: () => {
          this.removeKegFromTap(tap);
          this.modalController.dismiss({
            keg
          });
        }
      }]
    });

    await alert.present();
  }

  private removeKegFromTap(tap: ITap) {
    this.store.dispatch(fromTap.softUpdate({ id: tap.id ?? '', data: { kegId: null }, uid: tap.uBy ?? '' }));
  }

  async newKegModal() {
    const modal = await this.modalController.create({
      component: NewKegPage,
      componentProps: {
        isModal: true,
      }
    });


    modal.onDidDismiss().then(async (data) => {
      await this.selectKeg(data.data.keg, this.taps())
    });

    return await modal.present();

  }
}
